export const MAX_FILE_BYTES = 10 * 1024 * 1024
export const MAX_TEXT_CHARACTERS = 500000

export const STATUS_LABELS = {
  PENDENTE: 'Aguardando indexação', INDEXANDO: 'Indexando', PRONTO: 'Disponível para redação',
  FALHOU: 'Falha na indexação', SEM_AREA: 'Área não informada', SEM_TEXTO: 'Texto necessário', ARQUIVADO: 'Arquivado',
}

export const EVENT_LABELS = {
  ENVIADO: 'Arquivo adicionado', MIGRADO: 'Histórico anterior incorporado',
  CLASSIFICACAO_ATUALIZADA: 'Classificação alterada', TEXTO_ATUALIZADO: 'Texto atualizado',
  METADADOS_ATUALIZADOS: 'Dados do documento atualizados',
  CRIADO: 'Arquivo adicionado', IMPORTADO: 'Arquivo adicionado', ATUALIZADO: 'Documento atualizado',
  CLASSIFICADO: 'Classificação alterada', INDEXACAO_INICIADA: 'Indexação iniciada',
  INDEXACAO_CONCLUIDA: 'Indexação concluída', INDEXACAO_FALHOU: 'Falha na indexação',
  ARQUIVADO: 'Documento arquivado', RESTAURADO: 'Documento restaurado',
}

export function validateFile(file) {
  if (!file || !/\.(pdf|docx|txt)$/i.test(file.name)) return 'Selecione um arquivo PDF, DOCX ou TXT.'
  if (file.size <= 0 || file.size > MAX_FILE_BYTES) return 'Selecione um arquivo não vazio de até 10 MB.'
  return ''
}

export function fieldsFromDetail(detail) {
  return {
    titulo: detail?.documento?.titulo || '', area: detail?.documento?.area || '',
    acao: detail?.documento?.acao || '', observacoes: detail?.documento?.observacoes || '',
    conteudoTexto: detail?.conteudoTexto || '',
  }
}

export function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes < 0) return 'Tamanho não informado'
  return bytes >= 1024 * 1024 ? `${(bytes / (1024 * 1024)).toFixed(1)} MB` : `${Math.max(1, Math.ceil(bytes / 1024))} KB`
}

export function formatDate(value) {
  if (!value || Number.isNaN(new Date(value).valueOf())) return 'Data não informada'
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value))
}

export function areaLabel(areas, key) {
  return areas.find((area) => area.key === key)?.label || key || 'Sem área'
}

export function isCanonicalAction(value, acoesCanonicas = []) {
  return Boolean(value) && acoesCanonicas.some((acao) => acao.codigo === value)
}

export function actionLabel(value, acoesCanonicas = []) {
  const canonicalName = acoesCanonicas.find((acao) => acao.codigo === value)?.nome
  if (canonicalName) return canonicalName
  const labels = { MANIFESTACAO: 'Manifestação', CONTESTACAO: 'Contestação', APELACAO: 'Apelação',
    PETICAO_INICIAL: 'Petição inicial', REPLICA: 'Réplica', EMBARGOS_DE_DECLARACAO: 'Embargos de declaração',
    CONTRARRAZOES: 'Contrarrazões', RECURSO: 'Recurso' }
  return labels[value] || value?.replaceAll('_', ' ') || 'Sem ação'
}

export function mutationError(result) {
  if (result.status === 409)
    return 'O documento foi alterado por outra operação. Suas edições foram preservadas. Confira a versão salva antes de tentar novamente.'
  return result.error || 'Não foi possível concluir a operação. Tente novamente.'
}

export function indexingMessage(code) {
  if (code?.includes('TIMEOUT')) return 'A indexação excedeu o tempo disponível. Tente novamente.'
  if (code?.startsWith('OLLAMA')) return 'A IA local não concluiu a indexação. Confira a disponibilidade dos modelos e tente novamente.'
  return 'A indexação não foi concluída. O original está salvo e você pode tentar novamente.'
}

export function pdfPageText(items, { trim = true } = {}) {
  const text = items.filter((item) => typeof item.str === 'string')
    .map((item) => `${item.str}${item.hasEOL ? '\n' : ' '}`).join('')
  return trim ? text.trim() : text
}
